export default __webpack_public_path__ + "static/media/comedy.2af7a015.png";